<script lang="ts">
	/**
	 * The icon of a licensing application, resolved from whichever of the three
	 * sources the application row has: an uploaded image, a Font Awesome class, or
	 * neither — in which case a neutral cube stands in so the row never renders a
	 * hole where every sibling has a glyph.
	 */

	import site from '../site';

	interface Props {
		/** Uploaded icon filename, when the application has one. */
		iconImageName?: string | null;
		/** Font Awesome class, when the application has one instead. */
		icon?: string | null;
		/** Application name, used for the image's alt text. */
		name: string;
		/** Tailwind size classes for the glyph box. */
		class?: string;
	}

	let { iconImageName = null, icon = null, name, class: className = 'h-5 w-5' }: Props = $props();

	/** API origin the uploaded icons are served from. */
	const apiBase = site.backend.baseURL;
</script>

{#if iconImageName}
	<img
		src="{apiBase}/uploads/applications/{iconImageName}"
		alt="{name} icon"
		class="{className} rounded object-contain dark:invert"
	/>
{:else}
	<i class="fa-solid {icon || 'fa-cube'} text-primary-600 dark:text-primary-400"></i>
{/if}
